<template>
  <div class="pre-cadastro-wrapper">
    <nav class="breadcrumb-nav">
      <router-link :to="{ name: 'apps-cliente-list' }" class="breadcrumb-link">
        <feather-icon icon="HomeIcon" size="14" />
        <span>Cadastros</span>
      </router-link>
      <feather-icon icon="ChevronRightIcon" size="14" class="breadcrumb-separator" />
      <router-link :to="{ name: 'apps-cliente-list' }" class="breadcrumb-link">
        <span>Clientes</span>
      </router-link>
      <feather-icon icon="ChevronRightIcon" size="14" class="breadcrumb-separator" />
      <span class="breadcrumb-current">Pré-cadastro</span>
    </nav>

    <div class="action-bar">
      <div class="action-bar-left">
        <span class="step-badge">
          <feather-icon icon="LayersIcon" size="14" />
          Etapa {{ currentStep + 1 }} de 4
        </span>
        <span class="step-name">{{ steps[currentStep].title }}</span>
      </div>
      <div class="action-bar-right">
        <button type="button" class="action-btn ghost-btn" @click="salvarRascunho" :disabled="salvandoRascunho">
          <feather-icon icon="SaveIcon" size="14" />
          <span class="btn-text">{{ salvandoRascunho ? 'Salvando...' : 'Salvar rascunho' }}</span>
        </button>
        <button type="button" class="action-btn secondary-btn" @click="previousStep" v-if="currentStep > 0">
          <feather-icon icon="ArrowLeftIcon" size="14" />
          <span class="btn-text">Voltar</span>
        </button>
        <button type="button" class="action-btn primary-btn" @click="avancarEtapa" v-if="currentStep < 3">
          <span class="btn-text">Próximo</span>
          <feather-icon icon="ArrowRightIcon" size="14" />
        </button>
        <button type="button" class="action-btn success-btn" @click="enviarFormularios" v-if="currentStep === 3">
          <feather-icon icon="CheckIcon" size="14" />
          <span class="btn-text">Finalizar</span>
        </button>
      </div>
    </div>

    <div class="wizard-container">
      <div class="progress-tracker-compact">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="progress-step-compact"
          :class="{
            'active': currentStep === index,
            'completed': currentStep > index,
            'disabled': currentStep < index
          }"
          @click="goToStep(index)"
        >
          <div class="step-dot">
            <feather-icon v-if="currentStep > index" icon="CheckIcon" size="10" />
            <span v-else>{{ index + 1 }}</span>
          </div>
          <span class="step-label">{{ step.title }}</span>
        </div>
      </div>

      <div class="form-card">
        <div class="step-header">
          <h2>{{ steps[currentStep].title }}</h2>
          <p>{{ steps[currentStep].description }}</p>
        </div>

        <div class="step-content">
          <validation-observer ref="formDadosBasicos" v-show="currentStep === 0">
            <div class="form-section">
              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    Território <span class="required">*</span>
                  </label>
                  <validation-provider #default="{ errors }" name="Território" rules="required">
                    <v-select
                      v-model="dataFormDadosBasicos.territorio"
                      :options="dataFromApiRepresentanteId"
                      :reduce="option => option.representanteid"
                      :get-option-label="option => `${option.representanteid} - ${option.representantenome}`"
                      placeholder="Digite o território"
                      :loading="loadingRepresentantes"
                      class="custom-v-select"
                    />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <!--
                <div class="form-group">
                  <label class="form-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="2" y1="12" x2="22" y2="12"></line>
                      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                    Micro Região
                  </label>
                  <div class="input-with-loader">
                    <b-form-input
                      v-model="dataFormDadosBasicos.microregiao"
                      placeholder="Micro Região"
                      disabled
                      class="custom-input"
                    />
                    <b-spinner v-if="loadingMicroRegiao" small class="input-spinner"></b-spinner>
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    Grupo
                  </label>
                  <validation-provider #default="{ errors }" name="Grupo">
                    <b-form-input
                      v-model="dataFormDadosBasicos.grupo"
                      placeholder="Digite o grupo"
                      class="custom-input"
                      :class="{ 'is-invalid': errors.length > 0 }"
                    />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                -->
              </div>

              <div class="checkbox-grid">
                <div class="checkbox-card" :class="{ 'checked': dataFormDadosBasicos.clienteNovoNaPraca }">
                  <b-form-checkbox v-model="dataFormDadosBasicos.clienteNovoNaPraca" class="custom-checkbox" />
                  <div class="checkbox-content">
                    <span class="checkbox-title">Cliente Novo na Praça</span>
                    <span class="checkbox-desc">Marque se for um cliente novo na região</span>
                  </div>
                </div>

                <div class="checkbox-card" :class="{ 'checked': dataFormDadosBasicos.aumentoCredito }">
                  <b-form-checkbox v-model="dataFormDadosBasicos.aumentoCredito" class="custom-checkbox" />
                  <div class="checkbox-content">
                    <span class="checkbox-title">Aumento de Crédito</span>
                    <span class="checkbox-desc">Solicitar aumento de limite de crédito</span>
                  </div>
                </div>

                <div class="checkbox-card" :class="{ 'checked': dataFormDadosBasicos.clientenovocla }">
                  <b-form-checkbox v-model="dataFormDadosBasicos.clientenovocla" class="custom-checkbox" />
                  <div class="checkbox-content">
                    <span class="checkbox-title">Cliente Novo na CLA</span>
                    <span class="checkbox-desc">Novo cliente na classificação</span>
                  </div>
                </div>

                <div class="checkbox-card" :class="{ 'checked': dataFormDadosBasicos.alteracaocadastral }">
                  <b-form-checkbox v-model="dataFormDadosBasicos.alteracaocadastral" class="custom-checkbox" />
                  <div class="checkbox-content">
                    <span class="checkbox-title">Alteração Cadastral</span>
                    <span class="checkbox-desc">Atualização de dados cadastrais</span>
                  </div>
                </div>
              </div>
            </div>
          </validation-observer>

          <validation-observer ref="formDadosCliente" v-show="currentStep === 1">
            <div class="form-section">
              <div class="form-grid three-cols">
                <div class="form-group full-width">
                  <label class="form-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    Razão Social <span class="required">*</span>
                  </label>
                  <validation-provider #default="{ errors }" name="Razão Social" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.razaosocial" placeholder="Razão Social da empresa" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Nome Fantasia</label>
                  <b-form-input v-model="dataFormDadosCliente.nomefantasia" placeholder="Nome fantasia" class="custom-input" />
                </div>

                <div class="form-group">
                  <label class="form-label">Matriz</label>
                  <b-form-input v-model="dataFormDadosCliente.matriz" placeholder="Código da matriz" class="custom-input" />
                </div>

                <div class="form-group">
                  <label class="form-label">CNPJ <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="CNPJ" rules="required">
                    <div class="input-with-action">
                      <b-form-input
                        v-model="dataFormDadosCliente.cnpj"
                        placeholder="00.000.000/0000-00"
                        v-mask="'##.###.###/####-##'"
                        class="custom-input"
                        :class="{ 'is-invalid': errors.length > 0 }"
                        @blur="buscarDadosCnpj"
                      />
                      <button
                        type="button"
                        class="input-action-btn"
                        @click="buscarDadosCnpj"
                        :disabled="buscandoCnpj || !dataFormDadosCliente.cnpj"
                        title="Buscar dados na Receita Federal"
                      >
                        <b-spinner v-if="buscandoCnpj" small />
                        <feather-icon v-else icon="SearchIcon" size="14" />
                      </button>
                    </div>
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                    <span class="cnpj-status" :class="cnpjStatusClass" v-if="cnpjStatusMessage">
                      <feather-icon :icon="cnpjStatusIcon" size="12" />
                      {{ cnpjStatusMessage }}
                    </span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Inscrição Estadual</label>
                  <b-form-input v-model="dataFormDadosCliente.incricaoestadual" placeholder="Inscrição estadual" class="custom-input" />
                </div>

                <div class="form-group">
                  <label class="form-label">Suframa</label>
                  <b-form-input v-model="dataFormDadosCliente.suframa" placeholder="Código Suframa" class="custom-input" />
                </div>
              </div>

              <div class="section-divider">
                <span>Endereço</span>
              </div>

              <div class="form-grid three-cols">
                <div class="form-group span-2">
                  <label class="form-label">Endereço <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Endereço" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.endereco" placeholder="Rua, número, complemento" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">CEP <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="CEP" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.cep" placeholder="00000-000" v-mask="'#####-###'" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Bairro <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Bairro" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.bairro" placeholder="Bairro" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Cidade <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Cidade" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.cidade" placeholder="Cidade" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">UF <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="UF" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.uf" placeholder="UF" maxlength="2" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="section-divider">
                <span>Contato</span>
              </div>

              <div class="form-grid three-cols">
                <div class="form-group">
                  <label class="form-label">Telefone <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Telefone" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.telefone" placeholder="(00) 00000-0000" v-mask="['(##) #####-####', '(##) ####-####']" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group span-2">
                  <label class="form-label">E-mail <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="E-mail" rules="required|email">
                    <b-form-input v-model="dataFormDadosCliente.email" placeholder="email@empresa.com.br" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Resp. Área Financeira <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Responsável Área Financeira" rules="required">
                    <b-form-input v-model="dataFormDadosCliente.responsavelareafinanceira" placeholder="Nome do responsável" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">E-mail Resp. Financeiro <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="E-mail Resp. Área Financeira" rules="required|email">
                    <b-form-input v-model="dataFormDadosCliente.emailrespoareafinanceira" placeholder="email@empresa.com.br" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">E-mail envio XML <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="E-mail envio Arquivo XML" rules="required|email">
                    <b-form-input v-model="dataFormDadosCliente.emailenvioxml" placeholder="xml@empresa.com.br" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
          </validation-observer>

          <validation-observer ref="LocalCobranca" v-show="currentStep === 2">
            <div class="form-section">
              <div class="info-banner">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <span>Preencha o endereço de cobrança caso seja diferente do endereço principal</span>
              </div>

              <div class="form-grid">
                <div class="form-group full-width">
                  <label class="form-label">Endereço <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Endereço" rules="required">
                    <b-form-input v-model="dataFormLocalCobranca.endereco" placeholder="Rua, número, complemento" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">CEP <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="CEP" rules="required">
                    <b-form-input v-model="dataFormLocalCobranca.cep" placeholder="00000-000" v-mask="'#####-###'" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Bairro <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Bairro" rules="required">
                    <b-form-input v-model="dataFormLocalCobranca.bairro" placeholder="Bairro" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Cidade <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Cidade" rules="required">
                    <b-form-input v-model="dataFormLocalCobranca.cidade" placeholder="Cidade" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">UF <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="UF" rules="required">
                    <b-form-input v-model="dataFormLocalCobranca.uf" placeholder="UF" maxlength="2" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form-group">
                  <label class="form-label">Telefone <span class="required">*</span></label>
                  <validation-provider #default="{ errors }" name="Telefone" rules="required">
                    <b-form-input v-model="dataFormLocalCobranca.telefone" placeholder="(00) 00000-0000" v-mask="['(##) #####-####', '(##) ####-####']" class="custom-input" :class="{ 'is-invalid': errors.length > 0 }" />
                    <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
          </validation-observer>

          <validation-observer ref="ClassificacaoCliente" v-show="currentStep === 3">
            <div class="form-section">
              <div class="classification-info">
                <h4>Selecione as categorias de atuação do cliente</h4>
                <p>Marque todas as opções aplicáveis ao perfil do cliente</p>
              </div>

              <div class="classification-grid">
                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.textil }" @click="dataFormClassificacao.textil = !dataFormClassificacao.textil">
                  <div class="card-icon textil">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20.38 3.46L16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"></path>
                    </svg>
                  </div>
                  <span class="card-label">Têxtil</span>
                  <div class="card-check" v-if="dataFormClassificacao.textil">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.esporte }" @click="dataFormClassificacao.esporte = !dataFormClassificacao.esporte">
                  <div class="card-icon esporte">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                      <path d="M2 12h20"></path>
                    </svg>
                  </div>
                  <span class="card-label">Esporte</span>
                  <div class="card-check" v-if="dataFormClassificacao.esporte">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.diversos }" @click="dataFormClassificacao.diversos = !dataFormClassificacao.diversos">
                  <div class="card-icon diversos">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="3" width="7" height="7"></rect>
                      <rect x="14" y="3" width="7" height="7"></rect>
                      <rect x="14" y="14" width="7" height="7"></rect>
                      <rect x="3" y="14" width="7" height="7"></rect>
                    </svg>
                  </div>
                  <span class="card-label">Diversos</span>
                  <div class="card-check" v-if="dataFormClassificacao.diversos">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.alimentar }" @click="dataFormClassificacao.alimentar = !dataFormClassificacao.alimentar">
                  <div class="card-icon alimentar">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                      <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                      <line x1="6" y1="1" x2="6" y2="4"></line>
                      <line x1="10" y1="1" x2="10" y2="4"></line>
                      <line x1="14" y1="1" x2="14" y2="4"></line>
                    </svg>
                  </div>
                  <span class="card-label">Alimentar</span>
                  <div class="card-check" v-if="dataFormClassificacao.alimentar">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.farma }" @click="dataFormClassificacao.farma = !dataFormClassificacao.farma">
                  <div class="card-icon farma">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"></path>
                      <line x1="12" y1="8" x2="12" y2="16"></line>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </div>
                  <span class="card-label">Farma</span>
                  <div class="card-check" v-if="dataFormClassificacao.farma">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.hospitalar }" @click="dataFormClassificacao.hospitalar = !dataFormClassificacao.hospitalar">
                  <div class="card-icon hospitalar">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                  </div>
                  <span class="card-label">Hospitalar</span>
                  <div class="card-check" v-if="dataFormClassificacao.hospitalar">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.varejo }" @click="dataFormClassificacao.varejo = !dataFormClassificacao.varejo">
                  <div class="card-icon varejo">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="9" cy="21" r="1"></circle>
                      <circle cx="20" cy="21" r="1"></circle>
                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg>
                  </div>
                  <span class="card-label">Varejo</span>
                  <div class="card-check" v-if="dataFormClassificacao.varejo">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.atacado }" @click="dataFormClassificacao.atacado = !dataFormClassificacao.atacado">
                  <div class="card-icon atacado">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="1" y="3" width="15" height="13"></rect>
                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                      <circle cx="5.5" cy="18.5" r="2.5"></circle>
                      <circle cx="18.5" cy="18.5" r="2.5"></circle>
                    </svg>
                  </div>
                  <span class="card-label">Atacado</span>
                  <div class="card-check" v-if="dataFormClassificacao.atacado">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.distribuidor }" @click="dataFormClassificacao.distribuidor = !dataFormClassificacao.distribuidor">
                  <div class="card-icon distribuidor">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
                      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                      <line x1="12" y1="22.08" x2="12" y2="12"></line>
                    </svg>
                  </div>
                  <span class="card-label">Distribuidor</span>
                  <div class="card-check" v-if="dataFormClassificacao.distribuidor">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>

                <div class="classification-card" :class="{ 'selected': dataFormClassificacao.conspropio }" @click="dataFormClassificacao.conspropio = !dataFormClassificacao.conspropio">
                  <div class="card-icon conspropio">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <span class="card-label">Cons. Próprio</span>
                  <div class="card-check" v-if="dataFormClassificacao.conspropio">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                </div>
              </div>
            </div>
          </validation-observer>

        </div>

        <div class="form-footer">
          <div class="footer-info">
            <span class="required-note">
              <span class="required">*</span> Campos obrigatórios
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

import {
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { avatarText } from '@core/utils/filter';
import axios from '@/libs/axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import Swal from 'sweetalert2';
import ReceitaWSService from '@/services/ReceitaWS.service';

extend('required', {
  ...required,
  message: 'Este campo é obrigatório',
});

extend('email', {
  ...email,
  message: 'O e-mail informado é inválido',
});

export default {
  components: {
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BSpinner,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      currentStep: 0,
      steps: [
        { title: 'Dados Básicos', description: 'Informações iniciais do cadastro' },
        { title: 'Dados do Cliente', description: 'Informações da empresa e contato' },
        { title: 'Local de Cobrança', description: 'Endereço para cobrança' },
        { title: 'Classificação', description: 'Categorias de atuação' },
      ],
      formularioPreenchido: [],
      buscandoCnpj: false,
      cnpjStatusMessage: '',
      cnpjStatusClass: '',
      cnpjStatusIcon: 'InfoIcon',
      salvandoRascunho: false,
      rascunhoKey: 'dkp_precadastro_rascunho',
      cnpjDebounceTimer: null,
      etapaValidada: [false, false, false, false],
      dataFormDadosBasicos: {
        clienteNovoNaPraca: false,
        aumentoCredito: false,
        territorio: '',
        clientenovocla: false,
        alteracaocadastral: false,
      },
      dataFromApiRepresentanteId: [],
      loadingRepresentantes: false,
      dataFormDadosCliente: {
        razaosocial: '',
        nomefantasia: '',
        matriz: '',
        bairro: '',
        endereco: '',
        cidade: '',
        uf: '',
        cep: '',
        telefone: '',
        email: '',
        cnpj: '',
        incricaoestadual: '',
        suframa: '',
        responsavelareafinanceira: '',
        emailrespoareafinanceira: '',
        emailenvioxml: '',
      },
      dataFormLocalCobranca: {
        bairro: '',
        endereco: '',
        cidade: '',
        uf: '',
        cep: '',
        telefone: '',
      },
      dataFormClassificacao: {
        textil: false,
        esporte: false,
        diversos: false,
        alimentar: false,
        farma: false,
        hospitalar: false,
        varejo: false,
        atacado: false,
        distribuidor: false,
        conspropio: false,
      },
    };
  },
  mounted() {
    this.carregarDados();
    this.verificarRascunho();
  },
  watch: {
    'dataFormDadosCliente.cnpj': {
      handler(newVal) {
        if (newVal) {
          this.debounceBuscarCnpj();
        }
      },
      immediate: false,
    },
  },
  methods: {
    debounceBuscarCnpj() {
      if (this.cnpjDebounceTimer) {
        clearTimeout(this.cnpjDebounceTimer);
      }
      this.cnpjDebounceTimer = setTimeout(() => {
        const cnpj = this.dataFormDadosCliente.cnpj?.replace(/\D/g, '');
        if (cnpj && cnpj.length === 14) {
          this.buscarDadosCnpj();
        }
      }, 800);
    },
    async buscarDadosCnpj() {
      const cnpj = this.dataFormDadosCliente.cnpj?.replace(/\D/g, '');
      if (!cnpj || cnpj.length !== 14) {
        return;
      }
      this.buscandoCnpj = true;
      this.cnpjStatusMessage = 'Buscando dados do CNPJ...';
      this.cnpjStatusClass = 'status-info';
      this.cnpjStatusIcon = 'LoaderIcon';
      try {
        const dados = await ReceitaWSService.buscarCnpj(cnpj);
        const mapeados = ReceitaWSService.mapToFormFields(dados);
        const camposVazios = [];
        if (!this.dataFormDadosCliente.razaosocial && mapeados.razaosocial) {
          this.dataFormDadosCliente.razaosocial = mapeados.razaosocial;
          camposVazios.push('Razão Social');
        }
        if (!this.dataFormDadosCliente.nomefantasia && mapeados.nomefantasia) {
          this.dataFormDadosCliente.nomefantasia = mapeados.nomefantasia;
          camposVazios.push('Nome Fantasia');
        }
        if (!this.dataFormDadosCliente.endereco && mapeados.endereco) {
          this.dataFormDadosCliente.endereco = mapeados.endereco;
          camposVazios.push('Endereço');
        }
        if (!this.dataFormDadosCliente.bairro && mapeados.bairro) {
          this.dataFormDadosCliente.bairro = mapeados.bairro;
          camposVazios.push('Bairro');
        }
        if (!this.dataFormDadosCliente.cidade && mapeados.cidade) {
          this.dataFormDadosCliente.cidade = mapeados.cidade;
          camposVazios.push('Cidade');
        }
        if (!this.dataFormDadosCliente.uf && mapeados.uf) {
          this.dataFormDadosCliente.uf = mapeados.uf;
          camposVazios.push('UF');
        }
        if (!this.dataFormDadosCliente.cep && mapeados.cep) {
          this.dataFormDadosCliente.cep = mapeados.cep;
          camposVazios.push('CEP');
        }
        if (!this.dataFormDadosCliente.telefone && mapeados.telefone) {
          this.dataFormDadosCliente.telefone = mapeados.telefone;
          camposVazios.push('Telefone');
        }
        if (!this.dataFormDadosCliente.email && mapeados.email) {
          this.dataFormDadosCliente.email = mapeados.email;
          camposVazios.push('E-mail');
        }
        if (camposVazios.length > 0) {
          this.cnpjStatusMessage = `Dados preenchidos: ${camposVazios.join(', ')}`;
          this.cnpjStatusClass = 'status-success';
          this.cnpjStatusIcon = 'CheckCircleIcon';
        } else {
          this.cnpjStatusMessage = 'CNPJ encontrado. Campos já preenchidos mantidos.';
          this.cnpjStatusClass = 'status-info';
          this.cnpjStatusIcon = 'InfoIcon';
        }
      } catch (error) {
        console.error('Erro ao buscar CNPJ:', error);
        this.cnpjStatusMessage = error.message || 'Erro ao consultar CNPJ';
        this.cnpjStatusClass = 'status-error';
        this.cnpjStatusIcon = 'AlertCircleIcon';
      } finally {
        this.buscandoCnpj = false;
        setTimeout(() => {
          this.cnpjStatusMessage = '';
        }, 5000);
      }
    },
    verificarRascunho() {
      const rascunho = localStorage.getItem(this.rascunhoKey);
      if (rascunho) {
        try {
          const dados = JSON.parse(rascunho);
          const timestamp = dados.timestamp || 0;
          const agora = Date.now();
          const diasValido = 7 * 24 * 60 * 60 * 1000;
          if (agora - timestamp < diasValido) {
            Swal.fire({
              title: 'Rascunho encontrado',
              text: 'Deseja continuar de onde parou?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: 'Sim, continuar',
              cancelButtonText: 'Não, começar novo',
              confirmButtonColor: '#6366f1',
            }).then((result) => {
              if (result.isConfirmed) {
                this.carregarRascunho(dados);
              } else {
                localStorage.removeItem(this.rascunhoKey);
              }
            });
          } else {
            localStorage.removeItem(this.rascunhoKey);
          }
        } catch (e) {
          localStorage.removeItem(this.rascunhoKey);
        }
      }
    },
    carregarRascunho(dados) {
      if (dados.currentStep !== undefined) this.currentStep = dados.currentStep;
      if (dados.dataFormDadosBasicos) this.dataFormDadosBasicos = { ...this.dataFormDadosBasicos, ...dados.dataFormDadosBasicos };
      if (dados.dataFormDadosCliente) this.dataFormDadosCliente = { ...this.dataFormDadosCliente, ...dados.dataFormDadosCliente };
      if (dados.dataFormLocalCobranca) this.dataFormLocalCobranca = { ...this.dataFormLocalCobranca, ...dados.dataFormLocalCobranca };
      if (dados.dataFormClassificacao) this.dataFormClassificacao = { ...this.dataFormClassificacao, ...dados.dataFormClassificacao };
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Rascunho carregado',
          text: 'Seus dados foram restaurados',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    },
    salvarRascunho() {
      this.salvandoRascunho = true;
      const dados = {
        timestamp: Date.now(),
        currentStep: this.currentStep,
        dataFormDadosBasicos: this.dataFormDadosBasicos,
        dataFormDadosCliente: this.dataFormDadosCliente,
        dataFormLocalCobranca: this.dataFormLocalCobranca,
        dataFormClassificacao: this.dataFormClassificacao,
      };
      localStorage.setItem(this.rascunhoKey, JSON.stringify(dados));
      setTimeout(() => {
        this.salvandoRascunho = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Rascunho salvo',
            text: 'Seus dados foram salvos localmente',
            icon: 'SaveIcon',
            variant: 'success',
          },
        });
      }, 300);
    },
    async avancarEtapa() {
      const validado = await this.validarEtapaAtual();
      if (validado) {
        this.nextStep();
      }
    },
    async validarEtapaAtual() {
      let valido = false;
      let mensagemErro = '';
      switch (this.currentStep) {
        case 0:
          valido = await this.$refs.formDadosBasicos?.validate();
          if (!valido) mensagemErro = 'Preencha os campos obrigatórios dos dados básicos.';
          break;
        case 1:
          valido = await this.$refs.formDadosCliente?.validate();
          if (!valido) mensagemErro = 'Preencha os campos obrigatórios dos dados do cliente.';
          break;
        case 2:
          valido = await this.$refs.LocalCobranca?.validate();
          if (!valido) mensagemErro = 'Preencha os campos obrigatórios do local de cobrança.';
          break;
        case 3:
          const algumaSelecionada = Object.values(this.dataFormClassificacao).some((v) => v === true);
          valido = algumaSelecionada;
          if (!valido) mensagemErro = 'Selecione pelo menos uma classificação.';
          break;
        default:
          valido = true;
      }
      if (!valido) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Campos obrigatórios',
            text: mensagemErro,
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      }
      return valido;
    },
    goToStep(index) {
      if (index <= this.currentStep) {
        this.currentStep = index;
      }
    },
    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },
    previousStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    async carregarDados() {
      this.loadingRepresentantes = true;
      try {
        const response = await axios.get('representante-publico?perPage=10000');
        this.dataFromApiRepresentanteId = response.data.data;
      } catch (error) {
        console.error('Erro ao carregar representantes:', error);
      } finally {
        this.loadingRepresentantes = false;
      }
    },
    async enviarFormularios() {
      if (
        this.dataFormDadosBasicos.territorio === ''
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Alerta',
            text: 'Por favor, preencha todos os campos obrigatórios dos dados básicos.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (
        this.dataFormDadosCliente.razaosocial === ''
        || this.dataFormDadosCliente.bairro === ''
        || this.dataFormDadosCliente.endereco === ''
        || this.dataFormDadosCliente.cidade === ''
        || this.dataFormDadosCliente.uf === ''
        || this.dataFormDadosCliente.cep === ''
        || this.dataFormDadosCliente.telefone === ''
        || this.dataFormDadosCliente.email === ''
        || this.dataFormDadosCliente.cnpj === ''
        || this.dataFormDadosCliente.responsavelareafinanceira === ''
        || this.dataFormDadosCliente.emailrespoareafinanceira === ''
        || this.dataFormDadosCliente.emailenvioxml === ''
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Alerta',
            text: 'Por favor, preencha todos os campos obrigatórios dos dados do cliente.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (
        this.dataFormLocalCobranca.bairro === ''
        || this.dataFormLocalCobranca.endereco === ''
        || this.dataFormLocalCobranca.cidade === ''
        || this.dataFormLocalCobranca.uf === ''
        || this.dataFormLocalCobranca.cep === ''
        || this.dataFormLocalCobranca.telefone === ''
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Alerta',
            text: 'Por favor, preencha todos os campos obrigatórios do local de cobrança.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.formularioPreenchido.push({
        dadosBasicos: {
          territorio: this.dataFormDadosBasicos.territorio,
          clienteNovoNaPraca: this.dataFormDadosBasicos.clienteNovoNaPraca,
          aumentoCredito: this.dataFormDadosBasicos.aumentoCredito,
          clientenovocla: this.dataFormDadosBasicos.clientenovocla,
          alteracaocadastral: this.dataFormDadosBasicos.alteracaocadastral,
        },
        dadosCliente: this.dataFormDadosCliente,
        LocalCobranca: this.dataFormLocalCobranca,
        ClassificacaoCliente: this.dataFormClassificacao,
      });

      await this.envioDadosFormulario();
    },

    async envioDadosFormulario() {
      Swal.fire({
        title: 'Enviando dados...',
        text: 'Por favor, aguarde enquanto processamos sua solicitação',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await axios.post('/cliente-pre-cadastro', this.formularioPreenchido);

        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Dados enviados com sucesso',
          confirmButtonText: 'OK',
        });

        console.log(response.data.body);

        this.$router.push({ name: 'apps-cliente-list' });

        // setTimeout(() => {
        //   window.location.reload();
        // }, 1500);
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Não foi possível enviar os dados. Por favor, tente novamente.',
          confirmButtonText: 'OK',
        });
      }
    },
  },
  setup() {
    return {
      avatarText,
    };
  },
};
</script>

<style lang="scss" scoped>
.pre-cadastro-wrapper {
  min-height: 100vh;
  background: var(--sf-surface-bg);
  padding: 0.75rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 0.75rem;
  font-size: 0.8125rem;
}

.breadcrumb-link {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--sf-surface-muted);
  text-decoration: none;
  transition: color 0.15s;
  &:hover { color: var(--sf-accent); }
}

.breadcrumb-separator { color: var(--sf-surface-muted); }
.breadcrumb-current { color: var(--sf-surface-text-dark); font-weight: 600; }

.action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0.75rem;
  background: var(--sf-card-bg);
  border: 1px solid var(--sf-card-border);
  border-radius: 6px;
  margin-bottom: 0.75rem;
}

.action-bar-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.step-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  background: var(--sf-accent-light);
  border: 1px solid var(--sf-card-border);
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--sf-accent);
}

.step-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--sf-surface-text-dark);
}

.action-bar-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

.ghost-btn {
  background: transparent;
  color: var(--sf-surface-muted);
  border: 1px solid var(--sf-card-border);
  &:hover:not(:disabled) { background: var(--sf-surface-bg); color: var(--sf-surface-text); }
}

.secondary-btn {
  background: var(--sf-card-bg);
  color: var(--sf-surface-text);
  border: 1px solid var(--sf-card-border);
  &:hover:not(:disabled) { background: var(--sf-surface-bg); }
}

.primary-btn {
  background: var(--sf-btn-primary-bg);
  color: var(--sf-btn-primary-text, #fff);
  &:hover:not(:disabled) { background: var(--sf-btn-primary-hover, #1d4ed8); }
}

.success-btn {
  background: var(--sf-btn-success-bg, #177f46);
  color: #fff;
  &:hover:not(:disabled) { background: var(--sf-btn-success-bg, #177f46); }
}

.wizard-container {
  background: var(--sf-card-bg);
  border-radius: 8px;
  border: 1px solid var(--sf-card-border);
  overflow: hidden;
}

.progress-tracker-compact {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--sf-surface-bg);
  border-bottom: 1px solid var(--sf-card-border);
  overflow-x: auto;
  flex-wrap: wrap;
}

.progress-step-compact {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 60px;
  opacity: 0.5;
  &.active, &.completed { opacity: 1; }
  &.disabled { cursor: default; }

  .step-dot {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: var(--sf-card-border);
    color: var(--sf-surface-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.6875rem;
    transition: all 0.2s;
  }

  .step-label {
    font-size: 0.625rem;
    color: var(--text-muted, #6c757d);
    text-align: center;
    font-weight: 500;
    white-space: nowrap;
  }

  &.active {
    .step-dot { background: var(--sf-accent); color: #fff; box-shadow: 0 2px 8px rgba(99, 102, 241, 0.35); }
    .step-label { color: var(--sf-accent); font-weight: 600; }
  }

  &.completed {
    .step-dot { background: #22c55e; color: #fff; }
    .step-label { color: #22c55e; }
  }
}

.form-card {
  padding: 1rem;
}

.step-header {
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--sf-card-border);

  h2 {
    font-size: 1rem;
    font-weight: 600;
    color: var(--sf-surface-text-dark);
    margin: 0;
  }

  p {
    font-size: 0.75rem;
    color: var(--sf-surface-muted);
    margin: 2px 0 0 0;
  }
}

.form-section {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;

  &.three-cols {
    grid-template-columns: repeat(3, 1fr);
  }

  .full-width {
    grid-column: 1 / -1;
  }

  .span-2 {
    grid-column: span 2;
  }
}

.form-group {
  .form-label {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--text-body, #495057);
    margin-bottom: 0.375rem;

    .required {
      color: #ef4444;
    }
  }
}

.custom-input, .custom-select-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--sf-form-border);
  border-radius: 6px;
  font-size: 0.8125rem;
  transition: all 0.15s;
  background: var(--sf-form-bg);
  color: var(--sf-form-text);

  &:focus {
    border-color: var(--sf-accent);
    background: var(--sf-form-bg);
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
    outline: none;
  }

  &.is-invalid {
    border-color: #ef4444;
  }

  &:disabled {
    background: var(--sf-surface-bg);
    color: var(--sf-surface-muted);
  }
}

.input-with-action {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .custom-input {
    flex: 1;
  }
}

.input-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid var(--sf-card-border);
  border-radius: 6px;
  background: var(--sf-card-bg);
  color: var(--sf-accent);
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background: var(--sf-accent-light);
    border-color: var(--sf-card-border);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.cnpj-status {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.375rem;
  font-size: 0.6875rem;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;

  &.status-info {
    background: #eef2ff;
        background: var(--sf-card-bg);
  }

  &.status-success {
    background: var(--sf-card-bg);
    color: #16a34a;
  }

  &.status-error {
    background: var(--sf-card-bg);
    color: #dc2626;
  }
}

.custom-v-select {
  ::v-deep .vs__dropdown-toggle {
          padding: 8px 12px;
          border: 2px solid var(--sf-form-border);
          border-radius: 10px;
          background: var(--sf-form-bg);
          color: var(--sf-form-text);
        }

        ::v-deep .vs__dropdown-toggle:focus-within {
          border-color: var(--sf-accent);
          background: var(--sf-form-bg);
          box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
        }
}

.input-with-loader {
  position: relative;

  .input-spinner {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
          color: var(--sf-accent);
  }
}

.error-message {
  display: block;
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 24px;

  &.compact {
    margin-top: 24px;
  }
}

.checkbox-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: var(--sf-surface-bg);
  border: 2px solid var(--sf-card-border);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--sf-accent);
    background: var(--sf-card-bg);
  }

  &.checked {
    border-color: #667eea;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  }

  .checkbox-content {
    flex: 1;

    .checkbox-title {
      display: block;
      font-weight: 600;
      color: var(--sf-surface-text-dark);
      font-size: 0.9rem;
    }

    .checkbox-desc {
      display: block;
      font-size: 0.8rem;
      color: var(--sf-surface-muted);
      margin-top: 2px;
    }
  }
}

.section-divider {
  display: flex;
  align-items: center;
  margin: 28px 0 20px;

  span {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
    font-size: 0.9rem;
    padding-right: 16px;
    padding-left: 16px;
  }

  &::after {
    content: '';
    flex: 1;
    height: 2px;
    background: linear-gradient(90deg, var(--sf-card-border) 0%, transparent 100%);
  }
}

.classification-info {
  text-align: center;
  margin-bottom: 24px;

  h4 {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--sf-surface-text-dark);
    margin: 0;
  }

  p {
    font-size: 0.9rem;
    color: var(--sf-surface-muted);
    margin: 4px 0 0 0;
  }
}

.classification-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.classification-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px 16px;
  background: var(--sf-surface-bg);
  border: 2px solid var(--sf-card-border);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    border-color: #667eea;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);

    .card-icon {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
    }
  }

  .card-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--sf-card-bg);
    color: var(--sf-surface-muted);
    transition: all 0.3s ease;
  }

  .card-label {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--sf-surface-text);
    text-align: center;
  }

  .card-check {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    background: var(--sf-btn-success-bg, #28a745);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }
}

.info-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: var(--sf-accent-light);
  border: 1px solid var(--sf-card-border);
  border-radius: 12px;
  margin-bottom: 24px;

  svg {
    color: var(--sf-accent);
    flex-shrink: 0;
  }

  span {
    font-size: 0.9rem;
    color: var(--sf-surface-text);
  }
}

.add-item-form {
  background: var(--sf-card-bg);
  border: 2px dashed var(--sf-card-border);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;

  h4 {
    font-size: 1rem;
    font-weight: 700;
    color: var(--sf-surface-text-dark);
    margin: 0 0 16px 0;
  }
}

.btn-add-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.items-list {
  h4 {
    font-size: 1rem;
    font-weight: 700;
    color: var(--sf-surface-text-dark);
    margin: 0 0 16px 0;
  }
}

.item-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: var(--sf-card-bg);
  border: 1px solid var(--sf-card-border);
  border-radius: 12px;
  margin-bottom: 12px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .item-info {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .item-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;

    &.bank {
      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    }

    &.partner {
      background: linear-gradient(135deg, #fd7e14 0%, #ffc107 100%);
    }
  }

  .item-details {
    .item-name {
      display: block;
      font-weight: 600;
      color: var(--sf-surface-text-dark);
      font-size: 0.95rem;
    }

    .item-meta {
      display: block;
      font-size: 0.85rem;
      color: var(--sf-surface-muted);
      margin-top: 2px;
    }
  }
}

.btn-remove {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: var(--sf-card-bg);
  color: #dc3545;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #dc3545;
    color: white;
  }
}

.empty-state {
  text-align: center;
  padding: 48px 24px;
  color: var(--sf-surface-muted);

  svg {
    opacity: 0.3;
    margin-bottom: 16px;
  }

  p {
    font-size: 1rem;
    font-weight: 600;
    color: var(--sf-surface-text);
    margin: 0;
  }

  span {
    font-size: 0.85rem;
    display: block;
    margin-top: 4px;
  }
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  background: var(--sf-surface-bg);
  border-top: 1px solid var(--sf-card-border);
}

.footer-info {
  .required-note {
    font-size: 0.85rem;
    color: var(--sf-surface-muted);

    .required {
      color: #dc3545;
    }
  }
}

.footer-actions {
  display: flex;
  gap: 12px;
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: var(--sf-card-bg);
  color: var(--sf-surface-text);
  border: 2px solid var(--sf-card-border);
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--sf-accent);
    color: var(--sf-accent);
  }
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: var(--sf-btn-primary-bg);
  color: var(--sf-btn-primary-text, #fff);
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(93, 84, 212, 0.4);
  }
}

.btn-success {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: var(--sf-btn-success-bg, #177f46);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(23, 127, 70, 0.4);
  }
}

@media (max-width: 1200px) {
  .classification-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 992px) {
  .classification-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .form-grid.three-cols {
    grid-template-columns: repeat(2, 1fr);
  }

  .progress-tracker-compact {
    padding: 0.5rem;
  }

  .progress-step-compact {
    min-width: 50px;
    .step-label { display: none; }
  }
}

@media (max-width: 768px) {
  .pre-cadastro-wrapper {
    padding: 0.5rem;
  }

  .action-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }

  .action-bar-left, .action-bar-right {
    justify-content: center;
    flex-wrap: wrap;
  }

  .btn-text { display: none; }

  .form-grid, .form-grid.three-cols {
    grid-template-columns: 1fr;
  }

  .form-grid .span-2 {
    grid-column: 1;
  }

  .checkbox-grid {
    grid-template-columns: 1fr;
  }

  .classification-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .form-card {
    padding: 0.75rem;
  }
}
</style>
